<template>
  <div id="app">
    <router-view />
    <!-- 棉花炭疽病信息展示弹窗 -->
    <div v-if="showCottonInfo" class="disease-modal" @click="closeCottonInfo">
      <div class="disease-content" @click.stop>
        <div class="disease-header">
          <h2>棉花炭疽病</h2>
          <span class="probability">极大概率</span>
          <button class="close-btn" @click="closeCottonInfo">×</button>
        </div>
        <div class="disease-body">
          <div class="feature-section">
            <h3>特征描述</h3>
            <p>{{ cottonDiseaseData.feature }}</p>
          </div>
          <div class="prevention-section">
            <h3>防治方法</h3>
            <div class="method-item">
              <h4>物理防治</h4>
              <div class="method-content" v-html="cottonDiseaseData.physics"></div>
            </div>
            <div class="method-item">
              <h4>化学防治</h4>
              <div class="method-content" v-html="cottonDiseaseData.chemistry"></div>
            </div>
            <div class="method-item">
              <h4>生物防治</h4>
              <div class="method-content" v-html="cottonDiseaseData.biology"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      showCottonInfo: false,
      cottonDiseaseData: {
        feature: '病斑初呈圆形或近圆形，颜色为黄褐色至深褐色，边缘清晰；病斑中央凹陷，有时呈现同心轮纹状；叶片严重感病时出现穿孔现象，果实受害后出现深陷的黑色病斑；高温高湿条件下病害发展迅速，雨后传播加剧。',
        physics: '- 选择排水良好的田块，避免积水造成的高湿环境<br>- 合理密植，保证田间通风透光，降低湿度<br>- 及时清除病残体，减少病原菌越冬场所<br>- 实行轮作制度，与非茄科作物轮作2-3年<br>- 雨后及时排水，减少田间湿度',
        chemistry: '- 发病初期喷施甲基硫菌灵或多菌灵进行预防<br>- 使用咪鲜胺、苯醚甲环唑等三唑类杀菌剂治疗<br>- 严重时可用氟环唑、丙环唑等内吸性杀菌剂<br>- 每10-15天喷药一次，连续2-3次<br>- 雨前雨后及时补喷，确保药效持续',
        biology: '- 应用枯草芽孢杆菌等生物制剂进行土壤处理<br>- 喷施木霉菌制剂抑制病原菌生长繁殖<br>- 使用放线菌提取物增强植株抗病能力<br>- 施用微生物有机肥改善土壤微生态环境<br>- 叶面喷施海藻提取物等生物刺激素'
      }
    }
  },
  methods: {
    showCottonDiseaseInfo() {
      this.showCottonInfo = true;
    },
    closeCottonInfo() {
      this.showCottonInfo = false;
    }
  },
  mounted() {
    // 监听来自子组件的棉花点击事件
    this.$root.$on('cottonClicked', this.showCottonDiseaseInfo);
  },
  beforeDestroy() {
    this.$root.$off('cottonClicked', this.showCottonDiseaseInfo);
  }
}
</script>

<style>
@import 'assets/styles/main.scss';

#app {
  font-family: "PingFangSC", "PingFang SC", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* 棉花炭疽病弹窗样式 */
.disease-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.disease-content {
  background: white;
  border-radius: 12px;
  max-width: 600px;
  max-height: 80vh;
  width: 90%;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.disease-header {
  background: linear-gradient(135deg, #4CAF50, #45a049);
  color: white;
  padding: 20px;
  border-radius: 12px 12px 0 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.disease-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.probability {
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.disease-body {
  padding: 25px;
}

.feature-section {
  margin-bottom: 25px;
}

.feature-section h3 {
  color: #2c3e50;
  margin: 0 0 15px 0;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 2px solid #4CAF50;
  padding-bottom: 8px;
}

.feature-section p {
  color: #555;
  line-height: 1.6;
  margin: 0;
  text-align: left;
}

.prevention-section h3 {
  color: #2c3e50;
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 2px solid #4CAF50;
  padding-bottom: 8px;
}

.method-item {
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}

.method-item h4 {
  background: #f5f5f5;
  margin: 0;
  padding: 12px 15px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
}

.method-content {
  padding: 15px;
  text-align: left;
  line-height: 1.6;
  color: #555;
}

.method-content ::v-deep br {
  margin-bottom: 8px;
}
</style>